const endpoints = {
  navbar: 'profile/navbar.json',
  routes: 'profile/routes.json',
  home: 'profile/home.json',
  social: 'profile/social.json',
  about: 'profile/about.json',
  skills: 'profile/skills.json',
  education: 'profile/education.json',
  experiences: 'profile/experiences.json',
  projects: 'profile/projects.json',
  services:'profile/services.json',
  contact: 'profile/contact.json',
  footer: 'profile/footer.json',
  sendEmail: 'https://jr-ai-consulting.vercel.app/api/sendEmail'

};

export default endpoints;
